// extracted by mini-css-extract-plugin
export default {"Fall":"Fall_Fall__c0cwo"};